export default __webpack_public_path__ + "static/media/bobo-profile.9a004c78.png";